import { render, staticRenderFns } from "./UploadManager2.vue?vue&type=template&id=978868ea&scoped=true&"
import script from "./UploadManager2.vue?vue&type=script&lang=js&"
export * from "./UploadManager2.vue?vue&type=script&lang=js&"
import style0 from "./UploadManager2.vue?vue&type=style&index=0&id=978868ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978868ea",
  null
  
)

export default component.exports